import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "../Application";
import * as Constants from "../Data/Constants";
import { GameType } from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import { GalleryItem } from "../GameObjects/GalleryItem";
import { GalleryPaintable } from "../GameObjects/GalleryPaintable";
import { PaintableDress } from "../GameObjects/PaintableDress";

export class GalleryDress extends GalleryPaintable {
    private static readonly DRESS_OFFSETS: PIXI.Point[] = [
        new PIXI.Point(12, 10),
        new PIXI.Point(0, -40),
    ];
    private _mannequin!: PIXI.Sprite;

    constructor(pCallback: (pItem: GalleryItem) => void) {
        super(GameType.DRESS, pCallback);

        this._homePos = new PIXI.Point(-315, 215);
        this._homeScale = 0.4;
        this._presentScale = 0.675;
        this._targetState = Constants.STATE_DRESS;
        this._hoverVO = VoiceOver.DRESS_BUTTON;

        this.createVisuals();
    }

    public presentItem(): TimelineLite {
        this.interactive = false;
        this._paintable!.scale.set(this._presentScale);
        this._paintable!.position.set(-this._size.x * 0.5 - this._paintable!.width * 0.5, -100);

        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._paintable!, 1.0, {
            x: 0,
            y: -100,
            ease: Sine.easeInOut,
        });
        return timeline;
    }

    public moveItemToWall(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this._paintable!, 1.0, {
            x: this._homePos.x + GalleryDress.DRESS_OFFSETS[this.recentIndex].x,
            y: this._homePos.y + GalleryDress.DRESS_OFFSETS[this.recentIndex].y,
            ease: Sine.easeInOut,
        }, 0);
        timeline.to(this._paintable!.scale, 1.0, {
            x: this._homeScale,
            y: this._homeScale,
            ease: Sine.easeInOut,
        }, 0);
        timeline.call(() => {
            this.interactive = true;
            HLF.PixiUtils.setParent(this._paintable!, this._visuals);
        });
        return timeline;
    }

    public cacheVisuals(): PIXI.Texture {
        const scale: number = this._paintable!.scale.x;
        this._paintable!.scale.set(1);
        this._paintable!.position.copy(HLF.PointUtils.multiply(this._paintable!.position, 1 / scale));
        this._mannequin.scale.set(1 / scale);
        const texture: PIXI.Texture = Application.instance.renderer.generateTexture(
            this._visuals,
            undefined,
            Application.instance.renderer.resolution,
        );
        this._paintable!.scale.set(scale);
        this._paintable!.position.copy(HLF.PointUtils.multiply(this._paintable!.position, scale));
        this._mannequin.scale.set(1);
        return texture;
    }

    protected createVisualDefault(): void {
        this._mannequin = this.createMannequin();
        this._visuals.addChild(this._mannequin);

        this._visuals.position.copy(this._homePos);
    }

    protected createVisualComplete(): void {
        this._mannequin = this.createMannequin();
        this._visuals.addChild(this._mannequin);
        this._visuals.position.copy(this._homePos);

        this._paintable = new PaintableDress(this.recentIndex, false);
        this.addChild(this._paintable);
    }

    protected createVisualCached(): void {
        super.createVisualCached();
        this._cached!.scale.set(this._homeScale);
    }

    private createMannequin(): PIXI.Sprite {
        return HLF.PixiUtils.makeSprite("menu-button-dress-bw", Constants.SPRITESHEET_MENU);
    }
}
